import type {
    ServicePrincipal,
    ServicePrincipalServiceCreateCredentialResponse,
} from 'pbts/c1/api/service_principal/v1/service_principal'
import { ServicePrincipalRef } from 'pbts/c1/api/service_principal/v1/service_principal'
import { ServicePrincipalServiceClient } from 'pbts/c1/api/service_principal/v1/service_principal.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const createServicePrincipalApi = createMutationApi(
    ServicePrincipalServiceClient,
    'create',
    (r): ServicePrincipal => r?.servicePrincipal as ServicePrincipal,
    ServicePrincipalRef.typeName,
)

export const getServicePrincipalApi = createUnaryApi(
    ServicePrincipalServiceClient,
    'get',
    (r): ServicePrincipal => r?.servicePrincipal as ServicePrincipal,
    ServicePrincipalRef.typeName,
)

export const updateServicePrincipalApi = createMutationApi(
    ServicePrincipalServiceClient,
    'update',
    (r): ServicePrincipal => r?.servicePrincipal as ServicePrincipal,
    ServicePrincipalRef.typeName,
)

export const deleteServicePrincipalApi = createMutationApi(
    ServicePrincipalServiceClient,
    'delete',
    undefined,
    ServicePrincipalRef.typeName,
)

export const listServicePrincipalsApi = createPagedListApi(
    ServicePrincipalServiceClient,
    'list',
    undefined,
    ServicePrincipalRef.typeName,
)

export const createServicePrincipalCredentialApi = createMutationApi(
    ServicePrincipalServiceClient,
    'createCredential',
    (r): ServicePrincipalServiceCreateCredentialResponse => r as ServicePrincipalServiceCreateCredentialResponse,
    ServicePrincipalRef.typeName,
)

export const listServicePrincipalCredentialsApi = createPagedListApi(
    ServicePrincipalServiceClient,
    'listCredentials',
    undefined,
    ServicePrincipalRef.typeName,
)

export const revokeServicePrincipalCredentialApi = createMutationApi(
    ServicePrincipalServiceClient,
    'revokeCredential',
    undefined,
    ServicePrincipalRef.typeName,
)
